import React from 'react';

/** A style object that prevents Material UI from creating that hard-edged hover background. */
export const hoverOverride = {
    "&:hover": {
        background: "radial-gradient(farthest-corner, rgba(179, 170, 158, 0.25) 50%, transparent 72%)"
    },
  };


/**Format text content for multiple lines of text.*/
export const getTextContent = (content: string | string[]) => {
    if (typeof content === "string"){
        return <p>{content}</p>
    }
    return (
        <>
        {content.map((item, index) => {
            return (
                <div key={`${index}-${item}`}>
                    <p>{item}</p>
                </div>
            );
        })}
        </>
    );
};